module.exports = __webpack_public_path__ + "./rules/SportsRulesSPA.4e60737e1f9ab8631666818be9057e8f.pdf";